
import React, { useEffect, useRef } from "react";
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import uniqid from 'uniqid';

import PromotionTile from "./PromotionTile";
import CategoryTitle from "./CategoryTitle";
import validatePromotion from "../utils/validate-promotion";
import ScrollButtons from './ScrollButtons';

import './promotionsRow.scss';

export default function PromotionsRow() {
    const user = useSelector((state) => state.user.data);
    const userLoggedIn = useSelector((state) => state.user.isLoggedIn);
    const promotions = useSelector((state) => state.promotions.list || []);

    const container = useRef(null);

    useEffect(() => { });

    return promotions?.length < 1 || (userLoggedIn && user?.depositsMade > 0) ? null :
        <Container fluid="lg" className='promotions-container game-row-container section-margin'>
            
            {/* Title */}
            <CategoryTitle title="Promotions" />
            
            <div className="position-relative">
                <div className="promotions-row-container" ref={container}>
                    
                    {/* Promotions */}
                    {
                        promotions.map(promotion => {
                            return validatePromotion(promotion, user) ?
                                <PromotionTile promotion={promotion} key={uniqid()} /> : null
                        })
                    }
                </div>

                {/* Scroll */}
                <ScrollButtons container={container} />
            </div>
        </Container>;
}